const PALETTE = [
  { bg: '#eef2ff', color: '#4f46e5', dot: '#6366f1' }, // indigo
  { bg: '#fee2e2', color: '#dc2626', dot: '#ef4444' }, // red
  { bg: '#ecfdf5', color: '#059669', dot: '#10b981' }, // green
  { bg: '#fffbeb', color: '#d97706', dot: '#f59e0b' }, // amber
  { bg: '#eff6ff', color: '#2563eb', dot: '#3b82f6' }, // blue
  { bg: '#f5f3ff', color: '#7c3aed', dot: '#8b5cf6' }, // violet
  { bg: '#fdf4ff', color: '#a21caf', dot: '#d946ef' }, // fuchsia
  { bg: '#fff1f2', color: '#be123c', dot: '#f43f5e' }, // rose
];

function hashColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export default function PerspectiveBadge({ value }) {
  if (!value) return null;
  const c = hashColor(value);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '3px 9px', borderRadius: 100,
      background: c.bg, color: c.color,
      fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
    }}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', background: c.dot, flexShrink: 0 }} />
      {value}
    </span>
  );
}
